// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WxpbPbOiw8Wq6rmoDQvL{padding:24px 20px 0;overflow-y:auto;overflow-x:hidden}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/members/ui/AssignMemberToInbox/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,eAAA,CACA,iBAAA","sourcesContent":[".wrap {\n  padding: 24px 20px 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `WxpbPbOiw8Wq6rmoDQvL`
};
export default ___CSS_LOADER_EXPORT___;
